import React, { useEffect, useRef } from 'react';
import './AboutUs.css';
import logoImg1 from '../../images/Doumicomgroup4.png';

const AboutUs = () => {
  const containerRef = useRef(null);

  useEffect(() => {
    const animatedElements = containerRef.current.querySelectorAll(
      '.reveal-right, .reveal-left'
    );

    const observerOptions = {
      root: null,
      threshold: 0.15,
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('active');
          observer.unobserve(entry.target);
        }
      });
    }, observerOptions);

    animatedElements.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <div className="about-us" ref={containerRef}>
      <div className="about-brand-container reveal-right">
        <h1 className="about-brand-title-main">ABOUT US</h1>
        <div className="about-brand-sub-row">
          <div className="about-brand-image-wrapper">
            <img src={logoImg1} alt="About Us" className="about-logo" />
          </div>
        </div>
      </div>

      <div className="about-intro-section reveal-left">
        <p className="about-intro-paragraph">
          <strong>DOUMICOM Group</strong> is a leading EPCM and PMC company delivering integrated engineering, construction, project
          management, and specialized oil & gas solutions across Nigeria.  Backed by global partnerships and strong
          local expertise, we provide reliable, end-to-end solutions that drive efficency, innovation, and sustainable 
          growth across the energy and industrial sectors.
        </p>
      </div>

      <div className="about-intro-section reveal-right">
        <h3 className="about-header">Who We Are</h3>
        <p className="about-intro-paragraph">
          Founded in 2000, DOUMICOM Group has grown into a diversified industrial and energy company operating 
          across Nigeria, supported by strategic international partnerships in the Middle East and beyond.
          <br /><br />
          Recognized for technical excellence, innovation, and reliable project execution, we deliver integrated 
          solutions across engineering, procurement, construction, industrial services, energy infrastructure, 
          and specialized oilfield operations.
          <br /><br />
          Backed by experienced engineering teams and globally recognized partners, DOUMICOM remains committed 
          to safety, quality, efficiency, and delivering long-term value to clients across the oil & gas, energy, 
          and industrial sectors.
        </p>
      </div>

      <div className="about-intro-section reveal-left">
        <h3 className="about-header">Our Values</h3>

        <div className="values-grid">
          <div className="value-item reveal-right">
            <h4 className="about-sub-header">Excellence</h4>
            <p className="about-intro-paragraph">
              We deliver the highest standards of engineering, project execution, and operational performance across every project.
            </p>
          </div>

          <div className="value-item reveal-left">
            <h4 className="about-sub-header">Integrity</h4>
            <p className="about-intro-paragraph">
              We conduct business with professionalism, transparency, and accountability, building lasting relationships based on trust.
            </p>
          </div>

          <div className="value-item reveal-right">
            <h4 className="about-sub-header">Safety & Quality</h4>
            <p className="about-intro-paragraph">
              Safety and quality guide everything we do, ensuring compliance, protecting people and assets, and delivering reliable results.
            </p>
          </div>

          <div className="value-item reveal-left">
            <h4 className="about-sub-header">Innovation</h4>
            <p className="about-intro-paragraph">
              We embrace advanced technologies and modern engineering practices to develop efficient, future-focused solutions.
            </p>
          </div>

          <div className="value-item reveal-right">
            <h4 className="about-sub-header">Partnership</h4>
            <p className="about-intro-paragraph">
              Through strong international partnerships and local expertise, we create integrated solutions that deliver lasting value.
            </p>
          </div>

          <div className="value-item reveal-left">
            <h4 className="about-sub-header">Sustainability</h4>
            <p className="about-intro-paragraph">
              We promote responsible, efficient, and environmentally conscious practices that support sustainable industrial growth.
            </p>
          </div>

          <div className="value-item reveal-right">
            <h4 className="about-sub-header">Reliability</h4>
            <p className="about-intro-paragraph">
              Our clients depend on us for consistent performance, dependable execution, and on-time project delivery.
            </p>
          </div>
        </div>
      </div>

      <div className="scroll-to-top-container">
        <button onClick={scrollToTop} className="scroll-to-top-btn" aria-label="Scroll to top">
          <div className="block-arrow-up"></div>
        </button>
      </div>
    </div>
  );
};

export default AboutUs;